













import {Component, Vue} from 'vue-property-decorator';
import hexy from 'hexy'

@Component
export default class HexDumpSieve extends Vue {
    hexDump: string = hexy.hexy(' '.repeat(16) + 'not implemented yet' + ' '.repeat(13), {
        format: "twos",
        html: true,
    });
}
